import type { OwaDate } from "owa-datetime";
import isDSTTransitionDate from "./isDSTTransitionDate";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { type DateRange, toDateRangeArray } from "./DateRange";

/**
 * Checks if any of the provided dates contain a DST transition.
 * This is useful for determining when calendar needs DST-aware logic
 *
 * @param dates Array of dates to check for DST transitions
 * @returns true if any date in the array is a DST transition date
 */
export default function isDSTTransitionDateInRange(dates: OwaDate[] | undefined): boolean {
    return ((isGlobalFeatureEnabled("cal-surface-dst-view") ||
        isGlobalFeatureEnabled("cal-surface-dst-view-v2")) &&
        !!dates &&
        dates.some(isDSTTransitionDate));
}

/**
 * Checks if the given date range includes a DST transition date.
 * @param dateRange The date range to check
 * @returns true if the date range includes a DST transition date
 */
export function isDSTTransitionDateInDateRange(dateRange: DateRange): boolean {
    return isDSTTransitionDateInRange(toDateRangeArray(dateRange));
}
